<template>
  <el-form ref="form" :model="formData" :rules="rules" size="small">
    <el-row :gutter="10">
      <el-col :span="4">
        <el-form-item
          :label="$l('form_label_salesPerson') || '业务人员'"
          prop="salesPersonCode"
        >
          <dict-select
            v-model="formData.salesPersonCode"
            :selectedLabel.sync="formData.salesPersonName"
            url="/master/common/dict/baseUserSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            clearable
            filterable
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item
          :label="$l('form_label_requestDate') || '申请日期'"
          prop="requestDate"
        >
          <el-date-picker
            v-model="formData.requestDate"
            :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            clearable
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item
          :label="$l('form_label_payeeType') || '收款方'"
          prop="payeeType"
        >
          <dict-select
            v-model="formData.payeeType"
            url="/master/common/dict/biz"
            :body="payeeTypeParams"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            filterable
            @change="payeeTypeChange"
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="formData.payeeType == 'S'">
        <el-form-item
          :label="$l('form_label_PayeeScm') || '收款供应商'"
          prop="payeeScmCode"
        >
          <dict-select
            v-model="formData.payeeScmCode"
            url="/master/common/dict/xzScmCooperated"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            clearable
            filterable
            @change="payeeScmChange"
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="formData.payeeType === 'C'">
        <el-form-item
          :label="$l('form_label_payeeCustomer') || '收款客户'"
          prop="payeeScmCode"
        >
          <dict-select
            v-model="formData.payeeScmCode"
            url="/digitalCenter/common/dict/customer"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            clearable
            filterable
            @change="payeeScmChange"
          ></dict-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="8">
        <el-form-item
          :label="$l('form_label_payeeScmBankName') || '收款方开户银行'"
        >
          <el-input v-model="formData.payeeScmBankName" readonly> </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          :label="$l('form_label_payeeScmBankAccountName') || '收款方账户名称'"
        >
          <el-input v-model="formData.payeeScmBankAccountName" readonly>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item
          :label="$l('form_label_payeeScmBankAccountNo') || '收款方银行账号'"
        >
          <el-input v-model="formData.payeeScmBankAccountNo" readonly>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item
          :label="$l('form_label_expensePayer') || '费用付款方'"
          prop="expensePayerCode"
        >
          <dict-select
            v-model="formData.expensePayerCode"
            :selectedLabel.sync="formData.expensePayerName"
            url="/master/common/dict/biz"
            :body="expensePayerParams"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item
          :label="$l('form_label_currencyUnit') || '付款单位'"
          prop="currencyUnit"
        >
          <dict-select
            v-model="formData.currencyUnit"
            url="/master/common/dict/biz"
            :body="currencyUnitParams"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            clearable
            filterable
          ></dict-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
          <el-input v-model="v_currencyAmount" readonly> </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item
          :label="$l('form_label_paymentMethod') || '付款方式'"
          prop="paymentMethod"
        >
          <dict-select
            v-model="formData.paymentMethod"
            url="/master/common/dict/biz"
            :body="paymentMethodParams"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
            filterable
            clearable
          ></dict-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import dayjs from 'dayjs'
import { request } from '@/api/service'
export default {
  props: { currencyAmount: { type: Number, default: 0 } },
  data() {
    return {
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        payeeType: 'S',
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
        payeeScmBankName: '',
        payeeScmBankAccountName: '',
        payeeScmBankAccountNo: '',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        payeeScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    v_currencyAmount() {
      return !this.currencyAmount ? '0' : this.currencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  methods: {
    async formValidate() {
      return await validate.formValidate([this.$refs.form])
    },
    getData() {
      return {
        ...this.formData,
        currencyAmount: this.currencyAmount,
        v_currencyAmount: this.v_currencyAmount,
      }
    },
    payeeTypeChange() {
      this.formData.payeeScmCode = ''
      this.formData.payeeScmBankName = ''
      this.formData.payeeScmBankAccountName = ''
      this.formData.payeeScmBankAccountNo = ''
    },
    async payeeScmChange(e) {
      const payeeType = this.formData.payeeType
      const payeeScmInfo =
        payeeType == 'C' ? await this.getCustData(e) : await this.getScmData(e)

      const { bankName, bankAccountName, bankAccountNo } = payeeScmInfo
      this.formData.payeeScmBankName = bankName
      this.formData.payeeScmBankAccountName = bankAccountName
      this.formData.payeeScmBankAccountNo = bankAccountNo
    },
    async getScmData(scmCode) {
      if (!scmCode) {
        return {}
      }
      const res = await request({
        url: '/digitalCenter/scmInfo/detail',
        method: 'post',
        data: { scmCode },
      }).catch(() => null)
      return (res || {}).body || {}
    },
    async getCustData(custCode) {
      if (!custCode) {
        return {}
      }
      const res = await request({
        url: '/digitalCenter/masterCustomer/detail',
        method: 'post',
        data: { custCode },
      }).catch(() => null)
      return (res || {}).body || {}
    },
  },
}
</script>

<style scoped></style>
